import { useParams } from 'react-router';

import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { useFormMutation } from 'mutations/useFormMutation';
import { useConfigPedidoStepContext } from 'pages/compra/configuracao-pedido/contexts';
import { ConfigPedidoImportarEstoque, ProdutoEstoque } from 'pages/compra/configuracao-pedido/types';

export function useMutateImportarEstoque({ initialData }: { initialData: ProdutoEstoque[] }) {
    const { setActiveStepSaved } = useConfigPedidoStepContext();
    const { mutate, isLoading } = useFormMutation();
    const { enqueueSnackbar } = useSnackbar();
    const { id } = useParams();
    const reactQuery = useQueryClient();

    /**
     * Retorna os dados formatados para envio ao backend.
     */
    const getFormattedData = (currentData: ProdutoEstoque[]) => {
        const currentIds = new Set(currentData.map((p) => p.idProduto));

        const deactivated = initialData
            .filter((p) => !currentIds.has(p.idProduto))
            .map((p) => ({
                idProduto: p.idProduto,
                idConfigPedido: Number(id),
                qtEstoqueAtual: p.qtEstoqueAtual || 0,
                qtEstoqueTotal: p.qtEstoqueTotal || 0,
                fgAtivo: false,
            }));

        const current = currentData.map((p) => ({
            idProduto: p.idProduto,
            idConfigPedido: Number(id),
            qtEstoqueAtual: p.qtEstoqueAtual || 0,
            qtEstoqueTotal: p.qtEstoqueTotal || 0,
            fgAtivo: p.fgAtivo,
        }));

        return [...current, ...deactivated];
    };

    const onSubmit = (formData: ConfigPedidoImportarEstoque) => {
        mutate(
            {
                url: '/gestao/configpedidoprodutoestoque/insertlist',
                formData: getFormattedData(formData.configPedidoImportarEstoque),
                preventSnack: true,
            },
            {
                onSuccess: (response: any) => {
                    enqueueSnackbar('Configuração de estoque salva com sucesso', { variant: 'success' });

                    setActiveStepSaved();

                    reactQuery.setQueryData(['config-pedido-importar-estoque', id], { configPedidoImportarEstoque: response.data });
                },
                onError: () => enqueueSnackbar('Falha ao salvar a configuração de estoque', { variant: 'error' }),
            },
        );
    };

    return { onSubmit, isLoading };
}
